import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';

import {
  getSection15TypeList,
  getLawList,
  getRegulation1List,
  getRegulation2List,
  getRegulation3List,
  getRegulation4List,
} from '@/lib/formItem';
import { required } from '@/lib/rule';
import { RegulationId } from '@/lib/enum';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection15Form',
  props: {
  isValid: {
    type: Boolean,
    required: true,
  },
  isEditing: {
    type: Boolean,
    required: true,
  },
  lawId: {
    type: Number,
    required: true,
  },
  applicableId: {
    type: Number,
    required: true,
    validator: (value: number) => {
      return [1, 2, 3, 4].includes(value);
    },
  },
  regulation1Id: {
    type: Number,
    required: true,
  },
  regulation2Id: {
    type: Number,
    required: true,
  },
  regulation3Id: {
    type: Number,
    required: true,
  },
  regulation4Id: {
    type: Number,
    required: true,
  },
  regulation5Id: {
    type: Number,
    required: true,
  },
},
  emits: ["update:isValid", "update:applicableId", "update:lawId", "update:regulation1Id", "update:regulation2Id", "update:regulation3Id", "update:regulation4Id", "update:regulation5Id"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:applicableId', data: number): void;
  (e: 'update:lawId', data: number): void;
  (e: 'update:regulation1Id', data: number): void;
  (e: 'update:regulation2Id', data: number): void;
  (e: 'update:regulation3Id', data: number): void;
  (e: 'update:regulation4Id', data: number): void;
  (e: 'update:regulation5Id', data: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



const form = ref<InstanceType<typeof VForm> | null>(null);

const searchLawValue = ref<string>('');
const searchRegulation1Value = ref<string>('');
const searchRegulation2Value = ref<string>('');
const searchRegulation3Value = ref<string>('');
const searchRegulation4Value = ref<string>('');



const selectedLawRegulation1List = computed(() => {
  const list = [
    {
      value: RegulationId.DEFAULT.value,
      text: '',
    },
    ...getRegulation1List().filter((item) => {
      return item.lawId === props.lawId;
    }),
  ];

  return list;
});

const selectedLawRegulation2List = computed(() => {
  const list = [
    {
      value: RegulationId.DEFAULT.value,
      text: '',
    },
    ...getRegulation2List().filter((item) => {
      return item.lawId === props.lawId;
    }),
  ];

  return list;
});

const selectedLawRegulation3List = computed(() => {
  const list = [
    {
      value: RegulationId.DEFAULT.value,
      text: '',
    },
    ...getRegulation3List().filter((item) => {
      return item.lawId === props.lawId;
    }),
  ];

  return list;
});

const selectedLawRegulation4List = computed(() => {
  const list = [
    {
      value: RegulationId.DEFAULT.value,
      text: '',
    },
    ...getRegulation4List().filter((item) => {
      return item.lawId === props.lawId;
    }),
  ];

  return list;
});

const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateApplicableId = (e: number): void => {
  emits('update:applicableId', e);
};

const updateLawId = (e: number): void => {
  emits('update:lawId', e);
};

const updateRegulation1Id = (e: number | null): void => {
  emits('update:regulation1Id', e ?? RegulationId.DEFAULT.value);
};

const updateRegulation2Id = (e: number | null): void => {
  emits('update:regulation2Id', e ?? RegulationId.DEFAULT.value);
};

const updateRegulation3Id = (e: number | null): void => {
  emits('update:regulation3Id', e ?? RegulationId.DEFAULT.value);
};

const updateRegulation4Id = (e: number | null): void => {
  emits('update:regulation4Id', e ?? RegulationId.DEFAULT.value);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,props, form, searchLawValue, searchRegulation1Value, searchRegulation2Value, searchRegulation3Value, searchRegulation4Value, emits, selectedLawRegulation1List, selectedLawRegulation2List, selectedLawRegulation3List, selectedLawRegulation4List, updateIsValid, updateApplicableId, updateLawId, updateRegulation1Id, updateRegulation2Id, updateRegulation3Id, updateRegulation4Id, getSection15TypeList, getLawList, required, RegulationId, VForm, sharedMessages }
}

})